exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".link-external {\n  text-align: right;\n  margin: 5px 0; }\n\n.description-main {\n  display: flex;\n  align-items: center; }\n\n.list {\n  list-style-type: square; }\n\n.fb_iframe_widget_fluid span {\n  width: 100% !important; }\n\n.fb-like iframe {\n  border: 0;\n  display: block;\n  margin: 0 auto;\n  max-width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Blog/Item/index.scss
// module id = 1058
// module chunks = 0